import Utilities from '../utilities/utilities';

export default class websiteMessage {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {


		window.addEventListener('DOMContentLoaded', () => {
			this.init();
		});

		window.addEventListener('NAVIGATE_IN', () => {
			this.init();
		});

		window.addEventListener('infiniteScrollAppended', () => {
			this.init();
		});
	}

	init() {

        var elName = '.js-website-message';
        var elClose = '.js-website-message-close';

        var $el = jQuery(elName);
        
        if ($el.length == 0) {
			return;
		}

		if (Utilities.getCookie('cookie-website-message')) {
			jQuery(elName).remove();
		}

		jQuery(elClose).on("click", function(e){

			if (jQuery(elClose).hasClass('js-website-message-set-cookie')) {
				const cookieCalcHour = 1/8;
				Utilities.setCookie('cookie-website-message', 'active', cookieCalcHour);
			}

			jQuery(elName).remove();

		});

    }
}